import orderTables from "./order-tables";
import orderTablesSchema from "./order-tables-schema";

import { combineReducers } from "redux";

export default combineReducers({
  orderTablesSchema,
  orderTables,
});
